// This file is ignored by prettier
import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'

import Footer from 'js/components/Footer'
import PasswordResetConfirmForm from 'js/components/forms/PasswordResetConfirmForm'
import PasswordResetForm from 'js/components/forms/PasswordResetForm'
import SignInForm from 'js/components/forms/SignInForm'
import Header from 'js/components/Headers/UnauthorizedHeader'
import CorrectiveActionForm from 'js/containers/CorrectiveActionForm'
import Help from 'js/containers/Help'
import PrivacyPolicy from 'js/containers/PrivacyPolicy'
import RegistrationFlowEntry from 'js/containers/RegistrationFlow'

import Paths from 'js/utils/unauthorizedPaths'

import 'scss/unauthorized-main.scss'

function UnauthorizedMain(): React.ReactElement {
  return (
    <Router>
      <div id='app'>
        <Header />
        <div id='maincontent' className='container'>
            <Routes>
              <Route path={Paths.signIn} element={<SignInForm />} />
              <Route path={Paths.passwordReset} element={<PasswordResetForm />} />
              <Route path={Paths.passwordResetConfirm} element={<PasswordResetConfirmForm />} />
              <Route path={Paths.register} element={<RegistrationFlowEntry />} />
              <Route path={Paths.privacyPolicy} element={<PrivacyPolicy />} />
              <Route path={Paths.help} element={<Help />} />
              <Route path={Paths.correctiveActionForm} element={<CorrectiveActionForm />} />
              {/* Default Route */}
              <Route path='/' element={<SignInForm />} />
            </Routes>
        </div>
        <Footer />
      </div>
    </Router>
  )
}

export default UnauthorizedMain